import React from 'react';
import { siteContent } from '../../data/content';
import './Actions.css';

const Actions = () => {
  const getTypeIcon = (type) => {
    const icons = {
      event: '🎭',
      milestone: '🎯',
      award: '🏆',
      fundraising: '💝',
      launch: '🚀',
      publication: '📚'
    };
    return icons[type] || '📅';
  };

  const getTypeColor = (type) => {
    const colors = {
      event: 'var(--color-primary)',
      milestone: 'var(--color-secondary)',
      award: 'var(--color-accent-dark)',
      fundraising: 'var(--color-accent)',
      launch: 'var(--color-primary)',
      publication: 'var(--color-secondary)'
    };
    return colors[type] || 'var(--color-primary)';
  };

  return (
    <section id="actions" className="actions section">
      <div className="container">
        <div className="actions__header">
          <h2 className="actions__title">{siteContent.actions.title}</h2>
        </div>
        
        <div className="actions__timeline">
          <div className="actions__timeline-line"></div>
          
          {siteContent.actions.timeline.map((action, index) => (
            <div 
              key={index} 
              className={`actions__timeline-item ${index % 2 === 0 ? 'actions__timeline-item--left' : 'actions__timeline-item--right'}`}
            >
              <div className="actions__timeline-content">
                <div className="actions__timeline-date">
                  {action.date}
                </div>
                <div className="actions__timeline-card">
                  <div 
                    className="actions__timeline-icon"
                    style={{ backgroundColor: getTypeColor(action.type) }}
                  >
                    <span className="actions__timeline-emoji">
                      {getTypeIcon(action.type)}
                    </span>
                  </div>
                  <div className="actions__timeline-text">
                    <h3 className="actions__timeline-title">
                      {action.title}
                    </h3>
                    <p className="actions__timeline-description">
                      {action.description}
                    </p>
                    <div className="actions__timeline-type">
                      {action.type.charAt(0).toUpperCase() + action.type.slice(1)}
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="actions__timeline-dot">
                <div className="actions__timeline-dot-inner"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Actions;

